import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../util/axiosConfig"; // JWT 인터셉터 적용된 axios

type Props = {
	onLoginSuccess: (token: string) => void;
};

const NaverCallback: React.FC<Props> = ({ onLoginSuccess }) => {
	const navigate = useNavigate();

	useEffect(() => {
		const hash = window.location.hash.substring(1); // "access_token=...&state=..."
		const params = new URLSearchParams(hash);

		const token = params.get("access_token");
		if (token) {
			console.log("네이버 access_token:", token);

			axios
				.post("/api/auth/naver", { access_token: token })
				.then((res) => {
					console.log("naver login response", res.data);

					const { status, token: jwt, userInfo } = res.data;

					if (status === "EXISTING" && jwt) {
						// ✅ 기존 회원 → JWT 저장 후 로그인
						localStorage.setItem("accessToken", jwt);
						onLoginSuccess(jwt);
						setTimeout(() => navigate("/"), 0);
					} else if ((status === "NEW" || status === "DELETED") && userInfo) {
						// ✅ 신규 회원 → userInfo를 localStorage에 저장 후 PrivacyConsentPage로 이동
						Object.entries(userInfo).forEach(([key, value]) => {
							if (value) localStorage.setItem(key, String(value));
						});
						navigate("/privacy-consent");
					} else {
						throw new Error("서버 응답 형식 오류");
					}
				})
				.catch((err) => {
					console.error("네이버 로그인 실패:", err);
					alert("네이버 로그인에 실패했습니다.");
					navigate("/"); // 실패 시 로그인 화면으로
				});
		} else {
			console.error("네이버 로그인 실패: access_token 없음");
			alert("네이버 로그인에 실패했습니다.");
			navigate("/"); // 로그인 화면
		}
	}, [navigate, onLoginSuccess]);

	return <div>네이버 로그인 처리중...</div>;
};

export default NaverCallback;
